export default __webpack_public_path__ + "static/media/gallery_04.18752db3.jpg";